import React from "react";
import { Route } from "react-router-dom";
// import CapitalCampaignFacility from "../components/capital-campaign-facility";
// import CapitalCampaignDigital from "../components/capital-campaign-digital";
import CapitalCampaign from "../components/capital-campaign";
import CampaignContact from "../components/campaign-contact";
import CampaignUpdates from "../components/campaign-updates";
import CorporatePartners from "../components/corporate-partners";
import NamingOpportunities from "../components/naming-opportunities";
import OurFacility from "../components/our-facility";
import WaysToGive from "../components/ways-to-give";
import EmbeddedDonationForm from "../components/test";
import FloatingChatWidget from "../components/FloatingChatWidget";

const FundraisingRoutes = () => {
  return (
    <>
      {/* <Route path="/capital-campaign/:id" element={<CapitalCampaignFacility />} /> */}
      <Route path="/capital-campaign" element={<CapitalCampaign />} />
      {/* <Route path="/capital-campaign/:id" element={<CapitalCampaignDigital />} /> */}
      <Route path="/our-facility" element={<OurFacility />} />
      <Route path="/ways-to-give" element={<WaysToGive />} />
      <Route path="/naming-opportunities" element={<NamingOpportunities />} />
      <Route path="/corporate-partners" element={<CorporatePartners />} />
      <Route path="/campaign-updates" element={<CampaignUpdates />} />
      <Route path="/campaign-contact" element={<CampaignContact />} />
      <Route path="/test" element={<EmbeddedDonationForm />} />
      <Route path="/test-chat" element={<FloatingChatWidget />} />
    </>
  );
};

export default FundraisingRoutes;
